import { render, staticRenderFns } from "./MoreAnalysis.vue?vue&type=template&id=40bdf202&scoped=true&"
import script from "./MoreAnalysis.vue?vue&type=script&lang=js&"
export * from "./MoreAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./MoreAnalysis.vue?vue&type=style&index=0&id=40bdf202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bdf202",
  null
  
)

export default component.exports